import { getCookie } from "../services/Cookies";
import { postRequest } from "../services/ApiServices";
import { ToastError } from "../services/ToastMsg";

export const getDefaultTab=()=>
{
  const serviceTypes=getCookie("serviceTypes").split(',');
  const defaultTab=getCookie("defaultTab");
  let tabIndex={Fuel:false,Lube:false,Tot:false};
  let tabOrder=[];
  serviceTypes.forEach((serviceType)=>{
    if(serviceType=="TOT")
    {
      tabIndex.Tot=true;
    }
    if((serviceType=="Lube Analysis"  || serviceType=="OCM" || serviceType=="SDA" || serviceType=="Grease" || serviceType=="Compatibility" || serviceType=="Ferrography") )
    {
      tabIndex.Lube=true;
    }
    if((serviceType=="FQT" || serviceType=="FSC" || serviceType=="FCA" || serviceType=="GCMS" || serviceType=="BQS"))
    {
      tabIndex.Fuel=true
    }
    
  });
  if(typeof defaultTab!="undefined" && defaultTab!="" && defaultTab!=null)
  {
    if(tabIndex[defaultTab]==true)
    {
      var tabi=0;
      switch(defaultTab)
      {
        case 'Fuel':
          tabi=0;
          break;
        case 'Lube':
          tabi=1;
          break;
        case 'Tot':
          tabi=2;
          break
      }
      tabOrder.push(tabi);
    }
  }
  if(tabIndex.Fuel==true && tabOrder.indexOf(0)==-1)
  {
    tabOrder.push(0);
  }
  if(tabIndex.Lube==true && tabOrder.indexOf(1)==-1)
  {
    tabOrder.push(1);
  }
  if(tabIndex.Tot==true && tabOrder.indexOf(2)==-1)
  {
    tabOrder.push(2);
  }
  return tabOrder;
  

}

export const getDefaultTabName=()=>
{
  const serviceTypes=getCookie("serviceTypes").split(',');
  let tabIndex=[];
  let tabs=getDefaultTab();
  tabs.forEach((idx)=>{
    switch (idx)
    {
      case 0:
        tabIndex.push("Fuel");
        break;
      case 1:
        tabIndex.push("Lube");
        break;
      case 2:
        tabIndex.push("Tot");
        break;
    }
  });
  return tabIndex;


}
export const getTrendsShip=()=>
{
  const serviceTypes=getCookie("serviceTypes").split(',');
  let tabIndex=[];
  serviceTypes.forEach((serviceType)=>{
    if(serviceType=="TOT")
    {
      tabIndex.push("Tot");
    }
    if((serviceType=="Lube Analysis"  || serviceType=="OCM" || serviceType=="SDA" || serviceType=="Grease" || serviceType=="Compatibility" || serviceType=="Ferrography") )
    {
      tabIndex.push("Lube");
    }
    if((serviceType=="FQT" || serviceType=="FSC" || serviceType=="FCA" || serviceType=="GCMS" || serviceType=="BQS"))
    {
      tabIndex.push("Fuel");
    }
    
  });
  return tabIndex.length>0?[...new Set(tabIndex)]:[];
}


export const logUserActivity=(activity)=>
{
  //
  const token = getCookie("token");
  // var CryptoJS = require("crypto-js");
  // var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(encryptedtoken), 'my-secret-key@123').toString();
  // var bytes = CryptoJS.AES.decrypt(ciphertext, 'my-secret-key@123');
  // var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  // console.log('token',decryptedData)
  const url =process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `User/Activities`;
  postRequest(url,{activityname:activity,sessionKey:token});
}

export const logBeforeLoginActivity=(activity,username)=>
{
  const token = getCookie("token");
 
  const url =process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Authenticate/Activities/${username}`;
  postRequest(url,{activityname:activity,sessionKey:token});
}